import React, { useState } from 'react';

//MUI
import CircularProgress from '@mui/material/CircularProgress';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import CssBaseline from '@mui/material/CssBaseline';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import backgroundImg from '../../assets/BackgroundNight.jpg';
import { styled } from '@mui/material/styles';
import { ArrowBackIos } from '@mui/icons-material';
import { Input, Typography } from '@mui/material';

//Icons
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';

//Selfmade
import Copyright from './copyright';

//React router dom
import { useNavigate } from 'react-router-dom';

import mainURL from '../../config/environment';
import queryString from 'query-string';
import $ from 'jquery';

const styles = {
  backgroundImg: {
    backgroundImage: `url(${backgroundImg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  },
  passwordInput: {
    backgroundColor: '#E4E4E4',
    borderRadius: '4px',
    opacity: '70%',
    fontWeight: '600',
    paddingLeft: 2,
    paddingRight: 2,
    height: '2.7rem',
    border: '2px',
    borderColor: 'red',
  },
  boxCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  boxContainer: {
    height: '90%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imgBoxContainer: {
    maxWidth: '32rem',
    width: '90%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: '30px',
    padding: '2rem',
    '@media (max-width: 768px)': {
      padding: '1.5rem',
      maxWidth: '28rem',
    },
    '@media (max-width: 480px)': {
      padding: '1rem',
      maxWidth: '24rem',
    },
  },
  titleBoxContainer: {
    mt: 6,
  },
  backButton: {
    backgroundColor: 'transparent',
    borderColor: 'white',
    textTransform: 'unset',
    fontWeight: 'bold',
    color: 'white',
    '&:hover': {
      borderColor: 'white',
    },
  },
};

export default function ResetPassword() {
  const navigate = useNavigate();
  //Loading management
  const [isLoading, setLoading] = useState(false);

  //Data management
  const [isPasswordValid, setPasswordValid] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [model, setModel] = useState({
    email: '',
    token: '',
    password: '',
    confirmPassword: '',
  });

  const doPasswordsMatch = Boolean(model.password === model.confirmPassword);

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    $.ajax({
      method: 'POST',
      url: mainURL + 'login/reset-password',
      contentType: 'application/json',
      data: JSON.stringify(model),
    })
      .done((res) => {
        setLoading(false);
        localStorage.setItem('userInfo', JSON.stringify(res));
        navigate('/Login');
      })
      .fail((res) => {
        setLoading(false);
        alert(res.responseText);
      });
  };

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const queryInfo = queryString.parse(window.location.search);

    switch (name) {
      case 'password':
        const isPasswordValid = Boolean(value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{4,}$/i));
        if (isPasswordValid) {
          setPasswordValid(true);
        } else {
          setPasswordValid(false);
        }
        setModel({
          ...model,
          [name]: value,
          token: queryInfo.Token,
          email: queryInfo.email,
        });
        break;

      default:
        setModel({
          ...model,
          [name]: value,
          token: queryInfo.Token,
          email: queryInfo.email,
        });
        break;
    }
  };

  const ButtonCss = styled(Button)`
    background: #44c554;
    font-weight: bold;
    text-transform: unset;
    font-size: 16px;
    color: white;
    &:hover,
    &:focus {
      background: #3db449;
    }
    &:active {
      background: #3db449;
    }
  `;
  return (
    <Box
      component="main"
      style={styles.backgroundImg}
      sx={{
        height: '100vh',
        width: '100vw',
        padding: '1rem 2rem',
      }}
    >
      <CssBaseline />

      <Box
        sx={{
          height: '3rem',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button
          sx={styles.backButton}
          startIcon={<ArrowBackIos />}
          onClick={() => navigate('/Login')}
        >
          Back to login
        </Button>
      </Box>

      <Box sx={{ ...styles.boxContainer, ...styles.boxCenter }}>
        <Box sx={{ ...styles.imgBoxContainer, ...styles.boxCenter }}>
          <img
            src="assets/images/Americas-Logo.png"
            alt="Logo"
            style={{
              height: 'auto',
              maxWidth: '16rem',
              width: '100%',
              '@media (max-width: 768px)': {
                maxWidth: '12rem',
              },
              '@media (max-width: 480px)': {
                maxWidth: '8rem',
              },
            }}
          />{' '}
          <Box sx={{ ...styles.titleBoxContainer, ...styles.boxCenter }}>
            <Typography
              variant="h2"
              sx={{
                color: 'white',
                fontWeight: '700',
                fontSize: '50px',
                '@media (max-width: 768px)': {
                  fontSize: '35px',
                },
                '@media (max-width: 480px)': {
                  fontSize: '28px',
                },
              }}
            >
              {'Reset password'}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'white',
                fontWeight: '500',
                fontSize: '16px',
                '@media (max-width: 768px)': {
                  fontSize: '14px',
                },
                '@media (max-width: 480px)': {
                  fontSize: '12px',
                },
              }}
            >
              {'Enter a new password and confirm it to reset your password.'}
            </Typography>
          </Box>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 5, width: '100%' }}>
            <FormControl fullWidth>
              <Typography sx={{ color: 'white', fontSize: '16px', mb: '0.5rem' }}>
                {'Password'}
              </Typography>

              <Input
                sx={styles.passwordInput}
                margin="dense"
                required
                name="password"
                type={showPassword ? 'text' : 'password'}
                id="password"
                autoComplete="password"
                onChange={handleChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            {!isPasswordValid ? (
              <FormHelperText sx={{ color: 'white' }}>
                {'Password must contain at least one uppercase, one lowercase and one number.'}
              </FormHelperText>
            ) : null}
            <FormControl fullWidth sx={{ mt: 2, mb: 2 }}>
              <Typography sx={{ color: 'white', fontSize: '16px', mb: '0.5rem' }}>
                {'Confirm password'}
              </Typography>
              <Input
                sx={styles.passwordInput}
                margin="dense"
                required
                name="confirmPassword"
                type={showPassword ? 'text' : 'password'}
                id="confirmPassword"
                autoComplete="current-password"
                onChange={handleChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            {!doPasswordsMatch ? (
              <FormHelperText sx={{ color: 'white' }}>{"Passwords don't match"}</FormHelperText>
            ) : null}

            {isLoading ? (
              <Grid container justifyContent={'center'} sx={{ mt: 3, mb: 2 }}>
                <CircularProgress />
              </Grid>
            ) : (
              <React.Fragment>
                <ButtonCss type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 1 }}>
                  Set password
                </ButtonCss>
              </React.Fragment>
            )}
          </Box>
        </Box>
      </Box>
      <Copyright sx={{ mt: 8, mb: 4 }} />
    </Box>
  );

  /*  return (
    <Box
      component="main"
      style={styles.backgroundImg}
      sx={{
        height: '100vh',
        width: '100vw',
        padding: '1rem 2rem',
      }}
    >
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <img src="assets/images/Americas-Logo.png" alt="Logo" />
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 5, width: '100%' }}>
          <TextField
            error={!isPasswordValid}
            margin="dense"
            required
            fullWidth
            name="password"
            label="New password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={handleChange}
          />
          {!isPasswordValid ? (
            <FormHelperText>
              {'Password must contain at least one uppercase, one lowercase and one number.'}
            </FormHelperText>
          ) : null}
          <TextField
            error={!doPasswordsMatch}
            margin="dense"
            required
            fullWidth
            name="confirmPassword"
            label="Confirm password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={handleChange}
          />
          {!doPasswordsMatch ? <FormHelperText>{"Passwords don't match"}</FormHelperText> : null}
          {isLoading ? (
            <CircularProgress />
          ) : (
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Restore password
            </Button>
          )}
        </Box>
      </Box>
      <Copyright sx={{ mt: 8, mb: 4 }} />
    </Box>
  ); */
}
